import React, { useState } from 'react'
import { MdAccountCircle } from 'react-icons/md'

import { Maybe } from '../types'
import { gray } from '../styles/themeColors'
import { createImageUrl, useCurrentUser } from '../common'
import { useAppSelector } from '../hooks'

export const Avatar: React.FC<{
  userId?: Maybe<string>
  className?: string
  size?: string
  defaultSize?: number
  defaultColor?: string
  style?: React.CSSProperties
}> = ({
  userId,
  className = '',
  size = '100x100',
  defaultSize = 100,
  defaultColor = gray,
  style = {},
}) => {
  const { userId: currentUserId, firstName, lastName } = useCurrentUser()
  const [imageLoadError, setImageLoadError] = useState(false)
  const imageVersion = useAppSelector(state => state.site.imageVersion)

  const img = userId !== undefined ? userId : currentUserId

  const avatar = createImageUrl({
    path: `avatars/${img}.jpg`,
    size,
  })

  if (imageLoadError || !img) {
    return (
      <MdAccountCircle
        size={defaultSize}
        color={defaultColor}
        className={className}
        style={{ ...style }}
      />
    )
  }

  return (
    <img
      key={imageVersion}
      src={avatar}
      style={{ ...style }}
      className={className}
      alt={`${firstName} ${lastName}`}
      onError={() => setImageLoadError(true)}
    />
  )
}

export const MainEventImage: React.FC<{
  eventId: Maybe<string>
  className?: string
  size?: string
  defaultSize?: number
  defaultColor?: string
  style?: React.CSSProperties
  image?: string
}> = ({
  eventId,
  className = '',
  size = '100x100',
  defaultSize = 100,
  defaultColor = gray,
  style = {},
  image = 'main.jpg',
}) => {
  const [imageLoadError, setImageLoadError] = useState(false)
  const imageVersion = useAppSelector(state => state.site.imageVersion)

  const imageSrc = createImageUrl({
    path: `events/${eventId}/${image}`,
    size,
  })

  if (imageLoadError || !eventId) {
    return (
      <MdAccountCircle
        size={defaultSize}
        color={defaultColor}
        className={className}
        style={{ ...style }}
      />
    )
  }

  return (
    <img
      key={imageVersion}
      alt={image}
      src={imageSrc}
      style={{ ...style }}
      className={className}
      onError={() => setImageLoadError(true)}
    />
  )
}
